import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import { css } from "styled-components";

Object.assign(customerAddressFormStyles, {
    ...customerAddressFormStyles,
    cancelButton: {
        css: css`
            background-color: #999;
            border: none;
            margin-right: 10px;
            :hover {
                background-color: #999;
            }
        `,
    },
});
